// "1 photo" / "3 photos" — count + noun with a default "s" plural.
export function plural(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? "" : "s"}`;
}
